// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__wZWbY","modalForm":"UpgradeEpcsModal_modalForm__3Hhlh","modalFooter":"UpgradeEpcsModal_modalFooter__1IHVM"};